// https://github.com/HelloFax/HelloFax/blob/develop/lib/form/doctrine/TransmissionGroupForm.class.php#L17-L28

import { RequestType as RequestTypes } from 'generated/types/HelloRequest';

export { RequestTypes };
